import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';

import { TcProgressBarService } from '../components/progress-bar/progress-bar.service';
import { ResponseError } from '../models';
import { AlertService } from '../services';
import { AlertNewSnakbarService } from '../services/alert-new-snakbar.service';

@Injectable()
export class LoaderInterceptorService implements HttpInterceptor {

	private pendingRequests = 0;
	private showLoading = false;

	constructor(
		private tcProgressBarService: TcProgressBarService,
		private alertNewSnakbarService: AlertNewSnakbarService
	) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		if (this.blackListAction(req)) {
			return next.handle(req);
		}

		this.pendingRequests++;
		this.showLoadingBar();

		return next.handle(req).pipe(
			map((response: HttpResponse<any>) => {
				if (this.notHaveStructureUrl(req)) {
					return response;
				}
				if (response.body && response.body['successed'] === false) {
					response.body['messages'].forEach(message => {
						const sentences = message.split('. ');  // Split sentences
						if (sentences.length === 1) {
							// If there is only one sentence, display it without changes
							this.alertNewSnakbarService.snackBarError(message);
						} else {
							const firstSentence = sentences.shift(); // get the first sentence
							const remainingSentences = sentences.join('. '); // combine the rest with <br>

							this.alertNewSnakbarService.snackBarError(remainingSentences, firstSentence);
						}
					});
					const error = new ResponseError();
					error.data = response.body;
					throw error;
				}
				return response;
			}),
			tap({
				next: () => {
					this.hideLoadingBar();
				},
				error: () => {
					this.pendingRequests = 0;
					this.hideLoadingBar();
				}
			})
		);
	}

	private showLoadingBar(): void {
		if (!this.showLoading) {
			this.tcProgressBarService.show();
			this.showLoading = true;
		}
	}

	private hideLoadingBar(): void {
		this.pendingRequests--;
		if (this.pendingRequests <= 0) {
			this.tcProgressBarService.hide();
			this.showLoading = false;
			this.pendingRequests = 0;
		}
	}

	private blackListAction(req: HttpRequest<any>): boolean {
		const url = req.url.toLocaleLowerCase();

		if (
			url.indexOf('/Notification/Notify') > 0 ||
			url.indexOf('/notification') > 0 ||
			url.indexOf('/deposit/commission') > 0 ||
			url.indexOf('/refreshtoken') > 0
		) {
			return true;
		}

		return false;
	}

	private notHaveStructureUrl(req: HttpRequest<any>): boolean {
		const url = req.url.toLocaleLowerCase();

		if (
			url.indexOf('/ticket/download/') > 0 ||
			url.indexOf('/ticket/reply') > 0 ||
			url.endsWith('/verify/personalinformation') ||
			url.endsWith('/verify/address') ||
			url.indexOf('/transactions/exportexcel') > 0 ||
			url.endsWith('/exportexcel') ||
			url.indexOf('/request/message/download/') > 0 ||
			url.indexOf('/bankPayment/download/') > 0 ||
			url.indexOf('/cashPayment/download/') > 0 ||
			url.indexOf('/download/') > 0 ||
			url.indexOf('/creditpayment/download/') > 0 ||
			url.endsWith('verify/photo') ||
			url.endsWith('/bankpayment') ||
			url.endsWith('/cashpayment')
		) {
			return true;
		}

		return false;
	}
}
